import { useQContent } from '@exam-management/common/qcontent-provider';
import { SubQuestionPublishSchema } from '@exam-management/qcontent-management';
import { parseAsString, useQueryState } from 'nuqs';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import type { z } from 'zod';

import { PUBLISHABLE_ITEM_SET_SUB_QUESTION_STATUSES } from '../../constants';

type SubQuestionPublishFormInput = z.infer<typeof SubQuestionPublishSchema>;

export default function ItemSetSubQuestionPublishValidator() {
  const formContext = useFormContext<SubQuestionPublishFormInput>();
  const { qContent: question } = useQContent();
  const [validationMode] = useQueryState('validate', parseAsString);

  useEffect(() => {
    if (
      validationMode !== 'publish' ||
      !PUBLISHABLE_ITEM_SET_SUB_QUESTION_STATUSES.includes(question.status) ||
      formContext.formState.isLoading
    ) {
      return;
    }

    const formValues = formContext.getValues();

    const { success: isSuccess, error } = SubQuestionPublishSchema.safeParse(formValues);

    if (isSuccess) {
      return;
    }

    const { errors: zodErrors } = error;

    formContext.clearErrors();
    for (const zodError of zodErrors) {
      const field = zodError.path.join('.') as keyof SubQuestionPublishFormInput;
      formContext.setError(field, {
        type: 'manual',
        message: zodError.message,
      });
    }
  }, [question, validationMode, formContext.formState.isLoading]);

  return null;
}
